export default "__VITE_ASSET__DivZ_$FJ__"